import React from 'react';
import Link from 'next/link';

type Props = {
    page: number;
    total: number;
    url: string;
    params?: any;
    className?: string;
};

export default function Pagination({ page, total, url, params = null, className = '' }: Props) {
    let html: (React.ReactElement | null)[] = [];
    const search = new URLSearchParams(params || {});

    const constructLiForPage = (i) => {
        if (i > 0 && i <= total) {
            if (i !== 1) {
                search.set('page', i);
            } else {
                search.delete('page');
            }

            return (
                <li
                    key={i}
                    className={`${
                        i === page ? 'bg-light-green' : 'bg-dark-green hover:bg-dark-green/75 text-white'
                    } rounded-full`}>
                    {i === page ? (
                        <span className="p-4">{i}</span>
                    ) : (
                        <Link href={`${url}?${search.toString()}`} prefetch={false} className="p-4">
                            {i}
                        </Link>
                    )}
                </li>
            );
        }
        return null;
    };

    if (page - 2 > 1) {
        html.push(
            constructLiForPage(1),
            <li key="i1">
                <span className="p-4">...</span>
            </li>,
        );
    }

    for (let i = page - 2; i <= page + 2; i++) {
        html.push(constructLiForPage(i));
    }

    if (page + 2 < total) {
        html.push(
            <li key="i2">
                <span className="p-4">...</span>
            </li>,
            constructLiForPage(total),
        );
    }
    html = html.filter((h) => !!h);
    if (html.length <= 1) {
        return null;
    }

    return <ul className={`flex flex-row justify-center gap-4 ${className || ''}`}>{html.filter((h) => !!h)}</ul>;
}
